const CDN_LINK_DEFAULT = 'https://cdn.statcdn.com/static';
const CDN_LINK_ENTITY = 'https://cdn.statcdn.com';
const CDN_LINK_CROSSORIGIN = 'https://static1.statista.com';
const CDN_LINK_CMS = 'https://cdn.statcdn.com/CMS';
const CDN_LINK_STUDY = 'https://cdn.statcdn.com/Study';
const CDN_LINK_STUDY_DEV = 'https://cdn.statcdn.com/StudyDev';

const CDN_LINKS_MAP = {
    default: CDN_LINK_DEFAULT,
    entity: CDN_LINK_ENTITY,
    crossorigin: CDN_LINK_CROSSORIGIN,
    cms: CDN_LINK_CMS,
    study: CDN_LINK_STUDY,
    studyDev: CDN_LINK_STUDY_DEV,
};

function getCdnLink(link, cdn = '') {
    if (!link) {
        return false;
    }

    let cdnPath = CDN_LINK_DEFAULT;

    if (Object.prototype.hasOwnProperty.call(CDN_LINKS_MAP, cdn)) {
        cdnPath = CDN_LINKS_MAP[cdn];
    }

    return `${ cdnPath }/${ link }`;
}

export { getCdnLink };
